<div class="popup-overlay"></div>

<div class="popup-content">
  <button class="close-btn" (click)="closePopup()">×</button>

  <div class="left-panel" [class.collapsed]="isLeftPanelCollapsed">
    <button class="hamburger-btn" (click)="toggleLeftPanel()">
        <span class="arrow-icon">{{ isLeftPanelCollapsed ? '>' : '<' }}</span>
    </button>

    <ul>
      <li *ngFor="let opcion of opciones" (click)="seleccionarOpcion(opcion)">
        <i class="icon" [ngClass]="getIconClass(opcion)"></i>
        <span> {{ opcion }} </span>
      </li>
    </ul>
  </div>

  <div class="right-panel">
    <div [ngSwitch]="selectedOption">
        <div *ngSwitchCase="miPerfil">
          <app-mi-perfil></app-mi-perfil>
        </div>
      
        <div *ngSwitchCase="soporte">
            <app-soporte></app-soporte>
        </div>
        
        <div *ngSwitchCase="acercaDe">
            <app-acerca-de></app-acerca-de>
        </div>
        
        <div *ngSwitchCase="manualUsuario">
            <app-manual-usuario></app-manual-usuario>
        </div>

        <div *ngSwitchCase="faq">
            <app-preguntas-frecuentes></app-preguntas-frecuentes>
        </div>

        <div *ngSwitchCase="configuracion">
          <h3>{{ configuracion }}</h3>
          <p>Contenido de Configuración...</p>
        </div>

        <div *ngSwitchDefault>
            <h3>Selecciona una opción</h3>
        </div>
    </div>
  </div>
</div>